import { render, staticRenderFns } from "./safetyDataSheetDate.vue?vue&type=template&id=533ce0fc"
import script from "./safetyDataSheetDate.vue?vue&type=script&lang=js"
export * from "./safetyDataSheetDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports